<template>
    <div>
        <div>
            Welcome to Poker Season Manager <br>
            Currently in early Alpha.
        </div>
    </div>
</template>

<script>
export default {
  name: 'PSMHome'
}
</script>

<style lang="scss">

</style>
